// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1hhJk","inputDescription":"styles_inputDescription__3RsdV"};